const staticText = {
  legalDisclaimer: 'All logos and brand names are property of their respective owners, and the use does not imply endorsement of or affiliation with Smartcar.',
};

export default staticText;
